// removed by extract-text-webpack-plugin
module.exports = {"row":"AccountSettings-style__row__e2ee1a91","content":"AccountSettings-style__content__e2ee1a91","icon":"AccountSettings-style__icon__e2ee1a91","iconPinterest":"AccountSettings-style__iconPinterest__e2ee1a91 AccountSettings-style__icon__e2ee1a91","iconFacebook":"AccountSettings-style__iconFacebook__e2ee1a91 AccountSettings-style__icon__e2ee1a91","title":"AccountSettings-style__title__e2ee1a91","ctaWrapper":"AccountSettings-style__ctaWrapper__e2ee1a91","cta":"AccountSettings-style__cta__e2ee1a91","highlightedInfo":"AccountSettings-style__highlightedInfo__e2ee1a91"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/SocialNetworks/AccountSettings-style.scss
// module id = 2163
// module chunks = 63